module.exports = __webpack_public_path__ + "img/foodbeverage_icon.2447b030.svg";